import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLocation, useMatch } from "react-router-dom";

import classNames from "classnames";

import TournamentSidebar from "./TournamentSidebar";

import { scrollToTop } from "../../lib/utils";

const TournamentsLayout = (): React.JSX.Element => {
    const location = useLocation();
    const pathMatch =
        location.pathname === "/tournaments" ||
        /^\/tournaments\/\d+\/overview\/?$/.test(location.pathname);

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    return (
        <Container className="py-2 py-lg-5">
            {!pathMatch ? (
                <Row>
                    <Col lg={2} className={classNames("noPrint")}>
                        <TournamentSidebar />
                    </Col>
                    <Col>
                        <Outlet />
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col>
                        <Outlet />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default TournamentsLayout;
